import { useMemo } from 'react';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import { useRuleResults } from '../rules/RuleResultsContext';
import { useConfigentoStoreRef } from './StoreContext';
import { effectiveSelections } from './effectiveSelections';
import type { SelectionsMap } from './selections';

/**
 * The store's selections with everything the active rules removed stripped
 * out — see {@link effectiveSelections}. Any render path that *computes*
 * from the selections (price, payload, image layers) reads this instead of
 * the raw map; paths that render a single Characteristic's own input keep
 * reading the store, because the customer's pick has to stay in the field
 * once the rule stops matching.
 */
export function useEffectiveSelections(): SelectionsMap {
    const store = useConfigentoStoreRef();
    const selections = useStore(store, useShallow((s) => s.selections));
    const rules = useRuleResults();
    return useMemo(() => effectiveSelections(selections, rules), [selections, rules]);
}
